import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, pluck } from 'rxjs';
import { URLService } from './dynamic-url.service';
export interface GPTApp {
  bot: string;
  registrant: string;
  registrantType: string;
  _id: string;
  title?: string;
  name?: string;
  description?: string;
  icon?: string;
}

interface AppResponse {
  appDetails: GPTApp;
}

export interface GptAppConfig {
  botId: string;
  icon: string;
  name: string;
  description: string;
}

@Injectable({
  providedIn: 'root',
})
export class GPTAppsService {
  constructor(private http: HttpClient, private urlService: URLService) {}

  createApp(appConfig: GptAppConfig): Observable<GPTApp> {
    return this.http
      .post<AppResponse>(`${this.urlService.getDynamicUrl()}/app`, appConfig)
      .pipe(pluck('appDetails'));
  }

  getApp(appId: string): Observable<GPTApp> {
    return this.http
      .get<AppResponse>(`${this.urlService.getDynamicUrl()}/app/${appId}`)
      .pipe(pluck('appDetails'));
  }
}
